import { IWorkbookRevision } from '../types/IWorkbookRevision';
import { IGetItemsParams } from '../../../ts/ServerApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../ts/ServerApi/types/IGetItemsResult';
import { Request } from '../../../ts/ServerApi/requests/Request';

export interface IGetWorkbookVersionsParams extends IGetItemsParams {
}

export interface IGetWorkbookVersionsResult extends IGetItemsResult {
  versions: IWorkbookRevision[];
}

export class GetWorkbookVersionsRequest extends Request<IGetWorkbookVersionsParams, IGetWorkbookVersionsResult> {
  constructor(params: IGetWorkbookVersionsParams) {
    super('getWorkbookVersions', params);
  }
}
